export const APPLICATION_STATUS = {
  AWAITING: 'awaiting_documents',
  PENDING_REVIEW: 'pending_review',
  PENDING: 'pending',
  APPROVED: 'approved',
  DENIED: 'denied',
  CANCELED: 'canceled'
};

export const DB_APPLICATION_STATUS = {
  INCOMPLETE: 'applicationIncomplete',
  AWAITING_EIN_ORDER_COMPLETION: 'awaitingEinOrderCompletion',
  AWAITING_EIN_ORDER_CREATION: 'awaitingEinOrderCreation',
  AWAITING_EIN: 'awaitingEin',
  AWAITING_OPERATING_ADDRESS: 'awaitingOperatingAddress',
  SUBMITTED: 'applicationSubmitted',
  APPROVED: 'approved',
  AWAITING_CHECKOUT: 'awaitingCheckout',
  AWAITING_DOCUMENTS: 'awaitingDocuments',
  AWAITING_BANKING_ORDER_COMPLETION: 'awaitingBankingOrderCompletion',
  CANCELED: 'canceled',
  DENIED: 'denied',
  PENDING: 'pending',
  PENDING_REVIEW: 'pendingReview',
  STARTED: 'started',
  NOT_STARTED: 'notStarted',
  EXPIRED: 'expired',
  CLOSED: 'closed',
  NOT_QUALIFIED: 'notQualified'
};

export const INITIAL_PAYMENT_STATUS = {
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
  FAILED: 'failed'
};

export const FINISH_APP_STATUS = [
  DB_APPLICATION_STATUS.STARTED,
  DB_APPLICATION_STATUS.INCOMPLETE,
  DB_APPLICATION_STATUS.AWAITING_CHECKOUT,
  DB_APPLICATION_STATUS.EXPIRED
];

export const SHOW_AB_TEST = [
  DB_APPLICATION_STATUS.NOT_STARTED,
  DB_APPLICATION_STATUS.STARTED,
  DB_APPLICATION_STATUS.INCOMPLETE,
  DB_APPLICATION_STATUS.EXPIRED,
  DB_APPLICATION_STATUS.CANCELED,
  DB_APPLICATION_STATUS.CLOSED
];

export const ORDER_TASK_STATUS = {
  ACTIVE: 'active',
  CANCELED: 'canceled',
  PROCESSING: 'processing'
};

export const UNIT_REQUESTED_EIN_DEFAULT = '999999999';

export const MAIL_CARD = 'MAIL_CARD';
export const PROMPT_TO_LINK = 'PROMPT_TO_LINK';
export const HOW_MUCH_STEP = 'HOW_MUCH_STEP';
export const IS_THAT_CORRECT_STEP = 'IS_THAT_CORRECT_STEP';
export const OTP_STEP = 'OTP_STEP';

export const APPLICATION_STEPS = [
  MAIL_CARD,
  PROMPT_TO_LINK,
  HOW_MUCH_STEP,
  IS_THAT_CORRECT_STEP,
  OTP_STEP
];

export const ADDRESS = {
  BUSINESS: 'business',
  PERSONAL: 'personal'
};
